import PropTypes from 'prop-types'
import React, {useEffect, useMemo, useState} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

import {
    Box,
    useDisclosure,
    useMediaQuery
} from '@salesforce/retail-react-app/app/components/shared/ui'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

import {useGetHeader} from '../../clients/contentful'
import CartDrawer from '../../components/cart-drawer'
import {HOME_HREF} from '../../constants'
import DrawerMenu from '../drawer-menu'
import ListMenu from '../list-menu'
import Header from './index'
import './header-wrapper.scss'
import AnnouncementBar from './partials/announcement-bar'

export const HeaderWrapper = ({styles}) => {
    const history = useHistory()
    const location = useLocation()
    const {buildUrl} = useMultiSite()
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [isDesktop] = useMediaQuery('(min-width: 1366px)')
    const [isCartDrawerOpen, setIsCartDrawerOpen] = useState(false)
    const [enableBurgerAnimation, setEnableBurgerAnimation] = useState(false)

    const {data: header} = useGetHeader()
    const activeAnnouncementBar = useMemo(() => {
        const isActive = header?.announcementBar?.slides?.length > 0
        if (!isActive) return
        return header?.announcementBar
    }, [header])

    const onMenuClick = () => {
        isOpen ? onClose() : onOpen()
        setEnableBurgerAnimation(true)
    }

    const onLogoClick = () => {
        const path = buildUrl(HOME_HREF)
        return history.push(path)
    }

    const onCartClick = () => {
        if (location.pathname.match('/cart')) {
            const path = buildUrl('/cart')
            return history.push(path)
        }
        setIsCartDrawerOpen(false)
        // Close the drawer.
        onClose()
    }

    useEffect(() => {
        // Lets automatically close the mobile navigation when the
        // location path is changed.
        onClose()
    }, [location])

    useEffect(() => {
        if (!isDesktop && isOpen) {
            document.body.classList.add('modal-open')
        } else {
            document.body.classList.remove('modal-open')
        }
    }, [isDesktop, isOpen])

    if (location.pathname.includes('/store/registration')) return <></>

    return (
        <>
            {activeAnnouncementBar && (
                <AnnouncementBar data={activeAnnouncementBar} />
            )}
            <Box {...styles.headerWrapper} className="header" zIndex="1401">
                <Header
                    onMenuClick={onMenuClick}
                    onCloseMegaNavDrawer={onClose}
                    onLogoClick={onLogoClick}
                    onMyCartClick={onCartClick}
                    mobileNavOpen={isOpen}
                    enableBurgerAnimation={enableBurgerAnimation}
                    header={header}
                    activeAnnouncementBar={activeAnnouncementBar}
                >
                    {!isDesktop ? (
                        <DrawerMenu
                            isOpen={isOpen}
                            onClose={onClose}
                            onLogoClick={onLogoClick}
                            header={header}
                            paddingTop={activeAnnouncementBar ? 60 : 40}
                        />
                    ) : (
                        <ListMenu header={header} />
                    )}

                    <CartDrawer
                        isDrawerOpen={isCartDrawerOpen}
                        onDrawerClose={() => setIsCartDrawerOpen(false)}
                        type="cart"
                    />
                </Header>
            </Box>
        </>
    )
}

HeaderWrapper.displayName = 'HeaderWrapper'

HeaderWrapper.propTypes = {
    isCheckout: PropTypes.bool,
    styles: PropTypes.object
}
